import React from "react";
import { FeatureSection } from "./primitives";
import { Hero, Guardrails, RcmAgents, PaymentPosting, Eligibility, KpiReceivables, AuthUtilization } from "./illustrations";
import { Nav, RcmSection, FinalCta, SiteFooter } from "./sections";

/**
 * ABA Billing Platform — shared standalone dark, animated landing template.
 *
 * Presentation only, composed from per-section components. All copy comes in through the
 * required `content` prop ({ hero, features, rcm, finalCta }), so any number of pages can reuse
 * this template with different text — see `/aba-billing-platform` and `/aba-billing-platform-2`.
 * Styling is class-based and scoped under `.aba-platform` (abaBillingPlatformStyles.scss);
 * Archivo + Hanken Grotesk fonts load via `<link>` in `public/index.html`. Rendered outside the
 * shared `<Main>` shell, and the routes are excluded from `App.js` checkBar() (no app chrome).
 */
export const AbaBillingPlatformFragment = ({
  content,
  ctaHref = "https://therapylake.com/",
  demoHref = "https://calendly.com/therapylake/demo",
}) => {
  const { hero, features, rcm, finalCta } = content;
  return (
    <div className="aba-platform">
      <Nav ctaHref={ctaHref} />
      <Hero hero={hero} ctaHref={ctaHref} demoHref={demoHref} />

      <FeatureSection label="Prevent issues early" feature={features[0]}>
        <Guardrails />
      </FeatureSection>
      <FeatureSection label="Improve continuously" feature={features[1]} reversed>
        <RcmAgents />
      </FeatureSection>
      <FeatureSection label="Automate the flow" feature={features[2]}>
        <PaymentPosting />
      </FeatureSection>
      <FeatureSection label="Verify before you serve" feature={features[3]} reversed>
        <Eligibility />
      </FeatureSection>
      <FeatureSection label="Health of receivables" feature={features[4]}>
        <KpiReceivables />
      </FeatureSection>
      <FeatureSection label="Connected to the practice" feature={features[5]} reversed>
        <AuthUtilization />
      </FeatureSection>

      <RcmSection rcm={rcm} demoHref={demoHref} />
      <FinalCta finalCta={finalCta} ctaHref={ctaHref} demoHref={demoHref} />
      <SiteFooter />
    </div>
  );
};
